module.exports = __webpack_public_path__ + "img/airplane.b3c4c3e4.svg";